import { useOrgSettingsContext, IOrgSettings } from "../../context"

export const useOrgSettings = (): IUseConfiguration => ({
  orgSettings: useOrgSettingsContext()
})

interface IUseConfiguration {
  orgSettings: IOrgSettings | undefined
}
